import clsx from "clsx";
import { FC } from "react";
import WButton from "../wbutton/WButton";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/pro-regular-svg-icons";
import LCountDownTimer from "../lcount-down-timer/LCountDownTimer";
import parse from "html-react-parser";

/* eslint-disable-next-line */
interface LDarkImageContentItem {
  id: string;
  title?: string;
  description?: string;
}

export interface LDarkImageContentProps {
  id?: string;
  darkImageContentMainTitle?: string;
  buttonText?: string;
  buttonUrl?: string;
  backgroundImage?: string;
  left?: {
    id?: string;
    title?: string;
    items?: LDarkImageContentItem[];
  };
  right?: {
    id: string;
    title?: string;
    items?: LDarkImageContentItem[];
  };
  countDownTimer?: {
    endDate: Date;
    description?: string;
  };
}

export const LDarkImageContent: FC<LDarkImageContentProps> = ({
  id,
  darkImageContentMainTitle,
  buttonText,
  buttonUrl,
  backgroundImage,
  left,
  right,
  countDownTimer,
}) => {
  const router = useRouter();

  return (
    <div className="bg-ekblue">
      <div className="container z-20 flex flex-col gap-10 p-20 px-4 mx-auto text-white lg:flex-row lg:max-w-7xl">
        <div className="flex flex-col gap-4 lg:w-1/2">
          <h3 className="text-white">{left?.title}</h3>
          <div className="flex flex-col gap-4">
            {left?.items?.map((item) => (
              <DarkImageContentItem {...item} key={item?.id} />
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-4 lg:w-1/2">
          <h3 className="text-white">{right?.title}</h3>
          <div className="flex flex-col gap-4">
            {right?.items?.map((item) => (
              <DarkImageContentItem {...item} key={item?.id} />
            ))}
          </div>
        </div>
      </div>
      <div
        className="relative py-20 bg-ekblue"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "cover",
        }}
      >
        <div
          className={clsx([
            "text-center justify-center",
            "container z-20 flex flex-col gap-10 px-4 mx-auto text-white lg:max-w-7xl",
          ])}
        >
          <h1 className="text-white">
            {parse(darkImageContentMainTitle ?? "")}
          </h1>

          {countDownTimer && (
            <div className="mx-auto">
              <LCountDownTimer
                endDate={new Date(countDownTimer?.endDate)}
                description={countDownTimer?.description}
              />
            </div>
          )}
          <div className="mx-auto">
            {buttonText && buttonUrl && (
              <WButton
                text={buttonText}
                type="primary-red-btn"
                className="w-fit lg:mx-0"
                onClick={() => {
                  router.push(buttonUrl);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const DarkImageContentItem: FC<LDarkImageContentItem> = (item) => {
  return (
    <div className="flex flex-col gap-4 p-4 bg-white rounded-md">
      <div className="flex items-start gap-2">
        <FontAwesomeIcon icon={faCircle} className="mt-1 text-ekgreen" />
        <div className="flex flex-col gap-2">
          <span className="font-bold text-black font-sm">{item?.title}</span>
          <div className="text-black">{item?.description}</div>
        </div>
      </div>
    </div>
  );
};

export default LDarkImageContent;
